<template>
  <div class="tags-input">
    <!-- Tags list -->
    <div v-if="tags && tags.length > 0" class="d-inline-block mb-2">
      <b-form-tag
        v-for="tag in tags"
        :key="tag"
        :title="tag"
        variant="dark"
        class="tag-field-tag mr-1 mb-1"
        @remove="
          tags = tags.filter(t => t != tag);
          $emit('input', tags);
        "
      >
        {{ tag }}
      </b-form-tag>
    </div>
    <!-- Input field -->
    <b-input-group class="mb-2">
      <b-form-input
        ref="input"
        v-model="tagsInput"
        :placeholder="placeholder"
        :class="inputClass"
        @input="fetchSuggestions"
        @blur="hasFocus = false"
        @focus="onInputFocus"
        @keydown="onInputKeydown"
      />
      <b-input-group-append>
        <b-button
          :variant="hasFocus ? 'primary' : 'secondary'"
          @click="onAddClick"
        >
          Add
        </b-button>
      </b-input-group-append>
    </b-input-group>
    <div
      v-if="getSuggestions && (tagsSuggestions.length > 0 || tagsInput)"
      class="tags-field-auto-suggest"
    >
      <ul>
        <!-- Suggestion of what the user is currently writing in the input field -->
        <li v-if="tagsInput && !tagsSuggestions.includes(tagsInput)">
          <a href="#" @click.prevent="onSuggestionClick(tagsInput)">
            {{ tagsInput }}
          </a>
        </li>
        <li v-else-if="!tagsInput">
          <span class="font-style-italic">
            Start writing or choose a suggestion...
          </span>
        </li>
        <!-- (External) suggestions coming from the back-end or so -->
        <li v-for="suggestion in tagsSuggestions" :key="suggestion">
          <a href="#" @click.prevent="onSuggestionClick(suggestion)">
            {{ suggestion }}
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: Array,
    id: String,
    name: String,
    placeholder: String,
    disabled: Boolean,
    inputClass: String,
    state: Boolean,
    getSuggestions: Function
  },
  data() {
    return {
      tags: this.value || [],
      tagsInput: "",
      tagsSuggestions: [],
      hasFocus: false
    };
  },
  methods: {
    onInputKeydown(event) {
      if (event.keyCode === 13) {
        event.preventDefault();
        event.stopImmediatePropagation();
        this.addTag(this.tagsInput);
      }
    },
    onInputFocus() {
      this.hasFocus = true;
      this.fetchSuggestions();
    },
    onSuggestionClick(tag) {
      this.addTag(tag);
      this.$refs.input.focus();
    },
    onAddClick() {
      this.addTag(this.tagsInput);
      this.$refs.input.focus();
    },
    addTag(tag) {
      if (!tag || this.tags.includes(tag)) {
        return;
      }
      this.tags.push(tag);
      this.$emit("input", this.tags);
      this.tagsInput = "";
      this.fetchSuggestions();
    },
    fetchSuggestions() {
      // Store the current input of the input field
      // this.tagsInput = input;
      if (this.getSuggestions) {
        // Retrieve tag suggestions from outside the component
        this.tagsSuggestions = this.getSuggestions(this.tagsInput, this.tags);
      } else {
        this.tagsSuggestions = [];
      }
    },
    removeSuggestion(suggestion) {
      this.tagsSuggestions = this.tagsSuggestions.filter(s => s != suggestion);
    }
  }
};
</script>

<style lang="scss">
@import "~@/assets/sass/variables/main";

.tags-input {
  position: relative;
  &:focus-within {
    .tags-field-auto-suggest {
      display: block;
    }
  }
  & > .form-control {
    border: 0;
    padding: 0;
  }
  .tag-field-tag {
    background-color: $dark-50;
    span {
      padding-bottom: 2px;
      padding-top: 1px;
    }
  }
  .tags-field-auto-suggest {
    display: none;
    position: absolute;
    z-index: 10;
    top: 100%;
    width: 100%;
    background-color: white;
    border: 1px solid #eee;
    box-shadow: 0px 2px 3px 0px rgba(0, 0, 0, 0.1);
    ul {
      list-style: none;
      padding: 0;
      margin: 0;
      li {
        &:last-child a {
          border: 0;
        }
        a,
        span {
          display: block;
          color: $dark-75;
          border-bottom: 1px solid #eee;
          padding: 0.5rem 1rem;
        }
        span {
          font-style: italic;
          color: $dark-50;
        }
        a:hover {
          cursor: pointer;
          background-color: #fafafa;
        }
      }
    }
  }
  .form-control.is-valid {
    background-position: right bottom 0.9rem;
  }
}
</style>
